export default "/assets/text-menu.svg";